// LinkedIn Insight Tag, loaded only after marketing consent (Shopify Customer Privacy API).
// LinkedIn's <noscript> pixel is left out on purpose: it would fire without consent.
(function () {
  const script = document.currentScript;
  const partnerId = script && script.dataset.partnerId;
  if (!partnerId || window.msLinkedInInsight) return;

  let loaded = false;

  function load() {
    if (loaded) return;
    loaded = true;
    window._linkedin_partner_id = partnerId;
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(partnerId);
    if (!window.lintrk) {
      window.lintrk = function (a, b) {
        window.lintrk.q.push([a, b]);
      };
      window.lintrk.q = [];
    }
    const tag = document.createElement("script");
    tag.async = true;
    tag.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    document.head.appendChild(tag);
  }

  function loadIfAllowed() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.marketingAllowed === "function" && privacy.marketingAllowed()) load();
  }

  window.msLinkedInInsight = { loaded: () => loaded };
  document.addEventListener("visitorConsentCollected", (event) => {
    if (event.detail && event.detail.marketingAllowed) load();
  });

  if (window.Shopify && window.Shopify.customerPrivacy) {
    loadIfAllowed();
  } else if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
      if (!error) loadIfAllowed();
    });
  }
})();
